import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthBagService } from './auth-bag.service';
import { Observable, of, from, map, catchError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
	constructor(
		private readonly authBagService: AuthBagService,
		private readonly router: Router,
	) {}

	canActivate(): Observable<boolean | UrlTree> {
		if (this.authBagService.authStatus$.getValue()) {
			return of(true);
		}

		const access = this.authBagService.tokenGet();
		const refresh = this.authBagService.tokenRefreshGet();

		if (access && refresh) {
			return from(this.authBagService.authenticate({ access, refresh })).pipe(
				map((success) => success || this.router.createUrlTree(['/login'])),
				catchError(() => of(this.router.createUrlTree(['/login']))),
			);
		}

		return of(this.router.createUrlTree(['/login']));
	}
}
